import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { getDatabase, ref, update } from "firebase/database";


function ExcluirAluno(props) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const deleteUser = () => {
        const path = `companies/${props.data[0]}`;

        const db = getDatabase();

        update(ref(db, path), {
            isEmployeeVisible: false
        }).then(() => {
            props.removeClasses()
            handleClose()
        })
    }

    return (
        <>
            <Button variant="danger" onClick={handleShow}>
                Excluir
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Excluir Aluno</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Você está prestes a excluir o aluno <br /> <b>{props.data[2]}</b>
                    <br /> Essa ação é irreversível.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={deleteUser}>
                        Excluir
                    </Button>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ExcluirAluno